import React, { Component } from 'react'
import { Form, Input, Button, message } from 'antd'
import "../styles/AddStation.css"

import { addDocument } from "../redux/actions/Firebase";

import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { Row } from "antd";

class AddStation extends Component {

    constructor(props) {
        super(props)

        this.state = {
            position: [],
            number_slots: 0,
            date: "",
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (this.state.number_slots === 0) {
            message.warn("Debe de haber al menos un slot")
        } else if (this.state.position === [0, 0]) {
            message.warn("Posición no válida")
        } else if (this.state.date === "") {
            message.warn("Fecha no válida")
        }
        else {
            this.props.addDocument(this.state)
            message.success("Estación creada")
        }
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    render() {
        const isMobile = this.isMobileDevice();
        let marker = null;

        if (this.state.position.length > 0) {
            marker = (
                <Marker
                    position={{
                        lat: this.state.position[0],
                        lng: this.state.position[1],
                    }}
                />
            )
        }

        return (
            <div className="bodyDiv">
                {isMobile ?

                    <div className="mainDiv">
                        <Form layout="inline" onSubmit={this.handleSubmit} style={{width: '70%', display: 'block', textAlign: 'center'}}>
                            <Form.Item style={{width: '100%', margin: '5px auto', textAlign: 'center'}}>
                                <Input
                                    placeholder="Posición"
                                    // value={this.state.position[0] + ", " + this.state.position[1]}
                                    value={this.state.position.length > 0 ? this.state.position[0] + ", " + this.state.position[1] : '25.696672170989647, -100.31805296619564'}
                                    style={{textAlign: 'center'}}
                                    onChange={event => this.setState({ position: event.target.value })}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item style={{width: '100%', margin: '5px auto', textAlign: 'center'}}>
                                <Input
                                    placeholder="Número de slots"
                                    style={{textAlign: 'center'}}
                                    onChange={event => this.setState({ number_slots: event.target.value })}
                                />
                            </Form.Item>
                            <Form.Item style={{width: '100%', margin: '5px auto', textAlign: 'center'}}>
                                <Input
                                    placeholder="Fecha"
                                    type="date"
                                    style={{textAlign: 'center'}}
                                    onChange={event => this.setState({ date: event.target.value })}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        backgroundColor: 'white',
                                        color: '#096dd9',
                                        borderRadius: 25,
                                        height: 40,
                                        width: 200,
                                        marginLeft: 20
                                    }}
                                >
                                    Agregar
                        </Button>
                            </Form.Item>
                        </Form>
                    </div>
                    :
                    <div className="mainDiv">
                        <Form layout="inline" onSubmit={this.handleSubmit}>
                            <Form.Item>
                                <Input
                                    placeholder="Posición"
                                    // value={this.state.position[0] + ", " + this.state.position[1]}
                                    value={this.state.position.length > 0 ? this.state.position[0] + ", " + this.state.position[1] : '25.696672170989647, -100.31805296619564'}
                                    onChange={event => this.setState({ position: event.target.value })}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item>
                                <Input
                                    placeholder="Número de slots"
                                    onChange={event => this.setState({ number_slots: event.target.value })}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Input
                                    placeholder="Fecha"
                                    type="date"
                                    style={{ padding: 10 }}
                                    onChange={event => this.setState({ date: event.target.value })}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        backgroundColor: 'white',
                                        color: '#096dd9',
                                        borderRadius: 25,
                                        height: 40,
                                        width: 200,
                                        marginLeft: 20
                                    }}
                                >
                                    Agregar
        </Button>
                            </Form.Item>
                        </Form>
                    </div>
                }
                <Row style={{ width: '100%', height: 550 }} >
                    <Map
                        google={this.props.google}
                        zoom={13}
                        style={{ width: '100%', height: 550 }}
                        initialCenter={{
                            lat: 25.666202,
                            lng: -100.314178
                        }}
                        onClick={(props, data, e) => this.setState({ position: [e.latLng.lat(), e.latLng.lng()] })}
                    >
                        {marker}
                    </Map>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        firebase: state.firebase,
        stationsCollection: state.firebase.stationsCollection,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ addDocument }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(
    GoogleApiWrapper({
        apiKey: "AIzaSyBRt5tonSSUXJvKCIu4eZhDsjn8mEMOMl8"
    })(AddStation)
)
